const setAll = (state, allowed) => Object.fromEntries(Object.keys(state).map((name) => [
    name,
    {
        ...state[name],
        allowed: state[name].changable ? allowed : state[name].allowed,
        expiresAt: allowed ? state[name].allowExpires() : state[name].denyExpires()
    }
]));
export const isExpired = (state) => Object.values(state)
    .filter((policy) => policy.expiresAt !== null)
    .some((policy) => policy.expiresAt < new Date());
export const allow = (store) => (name) => store.update((state) => {
    const policy = state[name];
    if (policy.allowed || !policy.changable) {
        return state;
    }
    policy.onAllow();
    return { ...state, [name]: { ...policy, allowed: true, expiresAt: policy.allowExpires() } };
});
export const deny = (store, cookieDeleter) => (name) => store.update((state) => {
    const policy = state[name];
    if (!policy.allowed || !policy.changable) {
        return state;
    }
    policy.onDeny();
    cookieDeleter(policy.cookies);
    return { ...state, [name]: { ...policy, allowed: false, expiresAt: policy.denyExpires() } };
});
export const allowAll = (store) => () => {
    store.update((state) => {
        Object.values(state).forEach((policy) => {
            if (!policy.allowed && policy.changable) {
                policy.onAllow();
            }
        });
        return setAll(state, true);
    });
};
export const denyAll = (store, cookieDeleter) => () => {
    store.update((state) => {
        Object.values(state).forEach((policy) => {
            if (policy.allowed && policy.changable) {
                policy.onDeny();
                cookieDeleter(policy.cookies);
            }
        });
        return setAll(state, false);
    });
};
export const saveAll = (store) => () => {
    store.update((state) => {
        Object.values(state).forEach((policy) => {
            if (policy.changable) {
                if (policy.allowed)
                    policy.onAllow();
                else
                    policy.onDeny();
            }
            policy.expiresAt = policy.allowed ? policy.allowExpires() : policy.denyExpires();
        });
        return state;
    });
};
